import { PropTypes } from 'react'
import React from 'react'

const ShareThis = ({ text, url }) => {
	let encodedText = encodeURIComponent(text);
	let encodedUrl = encodeURIComponent(url);

	let shareOnFacebook = `https://www.facebook.com/sharer.php?u=${encodedUrl}&t=${encodedText}`;
	let shareOnTwitter = `https://twitter.com/share?text=${encodedText}&url=${encodedUrl}&via=Bridgeport`;
	let shareOnLinkedIn = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedText}&source=${encodedUrl}`;
	let shareOngplus = `https://plus.google.com/share?url=${encodedUrl}`;

	return (
		<div className="social-share">
			<div className="share-cover">
				<div className="title"><span>Share</span><i className="icon  icon-share-ellipses" data-grunticon-embed /></div>
				<a className="share-anchor share-facebook" target="_blank" href={ shareOnFacebook }>
					<i className="icon icon-facebook" data-grunticon-embed />
					<span className="screen-reader-text">Facebook</span>
				</a>
				<a className="share-anchor share-twitter" target="_blank" href={ shareOnTwitter }>
					<i className="icon icon-twitter" data-grunticon-embed />
					<span className="screen-reader-text">Twitter</span>
				</a>
				<a className="share-anchor share-linkedin" target="_blank" href={ shareOnLinkedIn }>
					<i className="icon icon-linkedin" data-grunticon-embed />
					<span className="screen-reader-text">Linkedin</span>
				</a>
		        <a className="share-anchor share-googleplus" target="_blank" href={ shareOngplus }>
		            <i className="icon icon-googleplus" data-grunticon-embed />
		            <span className='screen-reader-text'>Google Plus</span>
		        </a>
			</div>
		</div>
	);
}

ShareThis.propTypes = {
	text: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired
}

export default ShareThis;



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/blog-grid/components/share-this.js